import { GOAL_PAGE, GOAL_PATH_PATTERN } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';

export const goalRoute = createSiteRoute({
  exact: true,
  name: GOAL_PAGE,
  path: GOAL_PATH_PATTERN,
  capabilities: ['goals_app:access'],
  subproduct: 'townsquare-goals',
  enableRestrictedFallback: true,
});
